<template>
  <div class="big">
    <el-dialog :title="`${!isAdd ? '添加' : '编辑'}问答题`"
               :visible.sync="dialog"
               width="500px"
               style="text-align: left"
               :close-on-click-modal="false">
      <div class="add-answers-dia">
        <el-form :model="answersForm"
                 :rules="answersFormRules"
                 ref="answersFormRef"
                 label-width="60px">
          <el-form-item label="题目"
                        prop="title">
            <el-input v-model="answersForm.title"
                      placeholder="请输入"></el-input>
          </el-form-item>

          <div class="way">
            <el-form-item label="方式"
                          prop="answer_obj">
              <el-select v-model="answersForm.answer_obj"
                         placeholder="请选择方式">
                <el-option label="患者回答"
                           :value="1"></el-option>
                <el-option label="医生回答"
                           :value="2"></el-option>
                <el-option label="医生患者都可回答"
                           :value="3"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="是否必填"
                          prop="is_write"
                          label-width="80px"
                          class="answers-box">
              <el-radio-group v-model="answersForm.is_write">
                <el-radio :label="1">必填</el-radio>
                <el-radio :label="0">非必填</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>

          <el-form-item label=""
                        class="cus-textarea">
            <p class="prompt">暗提示文字，引导提示患者回答您的问题（非必填）</p>
            <el-input type="textarea"
                      v-model="answersForm.desc"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="text-align: center; padding: 10px 0">
        <el-button @click="closeShow(false)">取 消</el-button>
        <el-button type="primary"
                   @click="submitForm('answersFormRef')">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
export default {
  props: {
    isAdd: {
      type: Number,
      require: true
    },
    content: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data() {
    return {
      dialog: true,
      answersForm: {
        title: '',
        answer_obj: '',
        is_write: 1,
        desc: ''
      },
      answersFormRules: {
        title: [
          { required: true, message: '请输入题目', trigger: 'blur' },
          { max: 100, message: '题目长度100字以内', trigger: 'blur' }
        ],
        answer_obj: [
          { required: true, message: '请选择方式', trigger: 'change' }
        ],
        desc: [{ max: 30, message: '题目长度100字以内', trigger: 'blur' }]
      }
    };
  },
  created() {
    if (this.isAdd) {
      this.answersForm = _.pick(this.content, [
        'title',
        'answer_obj',
        'is_write',
        '$index',
        'desc'
      ]);
    }
  },
  methods: {
    closeShow(data) {
      this.$emit('closeShow', data);
    },
    //提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = Object.assign(this.answersForm, {
            item_type: 3
          });
          this.closeShow(data);
        } else {
          return false;
        }
      });
    },
    resetForm() {}
  }
};
</script>
<style lang="scss" scoped>
.add-answers-dia {
  padding: 20px 20px 0 20px;
  box-sizing: border-box;

  .way {
    display: flex;
    height: 50px;
    .answers-box {
      ::v-deep .el-form-item__content {
        display: flex;
        align-items: center;
        .el-radio-group {
          display: flex;
        }
      }
    }
  }
  .cus-textarea {
    margin-top: 10px;
    margin-bottom: 40px;
    .prompt {
      height: 20px;
      line-height: 20px;
      margin: 0;
      color: #cac7c7;
    }
  }
}
</style>
